export default __webpack_public_path__ + "static/media/logo192.58ff330f.png";